/* eslint-disable lingui/no-unlocalized-strings -- descrições do input da ferramenta do agente, em inglês canônico (U33) */
import { z } from 'zod';

import { CREATE_TEST_EMPLOYEE_EMPTY, type CreateTestEmployeeForm } from './create-test-employee.form';

/** Entrada da ferramenta "adicionar à lista" (agente): os mesmos campos, todos texto. */
export const createTestEmployeeInput = z.object({
  numeroInscricaoEmpregador: z.string().max(18).describe('Employer CNPJ, 14 characters'),
  nomeEmpregador: z.string().max(200),
  matricula: z.string().max(60),
  dataAdmissao: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).describe('Admission date, YYYY-MM-DD'),
  dataDesligamento: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  motivoDesligamento: z.string().max(10).optional(),
  elegivel: z.enum(['true', 'false']),
  motivoInelegibilidade: z.string().max(10).optional(),
  cpfTrabalhador: z.string().max(14).describe('Worker CPF, 11 digits'),
  nomeTrabalhador: z.string().max(200),
  exposicaoPolitica: z.enum(['0', '1']).optional(),
  sexo: z.enum(['1', '2']).describe('1 = male, 2 = female'),
  dataNascimento: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).describe('Birth date, YYYY-MM-DD'),
  codigoCategoriaTrabalhador: z.string().max(10),
  valorTotalVencimentos: z.string().regex(/^\d+$/).optional().describe('Total earnings in cents'),
  valorBaseMargem: z.string().regex(/^\d+$/).optional().describe('Margin base in cents'),
  numeroInscricaoEstabelecimento: z.string().max(18).optional(),
  classificacaoTributaria: z.string().max(10).optional(),
});
export type CreateTestEmployeeInput = z.infer<typeof createTestEmployeeInput>;

/** A entrada do agente como valores do formulário (o que ele não manda fica no default). */
export function inputToForm(input: CreateTestEmployeeInput): CreateTestEmployeeForm {
  return {
    ...CREATE_TEST_EMPLOYEE_EMPTY,
    ...(Object.fromEntries(Object.entries(input).filter(([, value]) => value !== undefined)) as Partial<CreateTestEmployeeForm>),
  };
}
